<template>
  <b-card :no-body="noBody" :class="[className, 'w-100']" border-variant="light">
    <slot></slot>
  </b-card>
</template>

<script>
export default {
  name: 'InvoiceFormCard',
  props: {
    className: {
      type: String,
      default: ''
    },
    noBody: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  border-radius: 10px;
  margin-bottom: 20px;
}
</style>
